import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter  } from '@angular/core';
import { Table } from 'primeng/table';
import { Administradora } from 'src/app/admihair/api/dto/administradora';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-usuario-franquia-listar',
  templateUrl: './usuario-franquia-listar.component.html',
  styleUrls: ['./usuario-franquia-listar.component.scss']
})
export class UsuarioFranquiaListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  loading: boolean = false;
  usuarios: Usuario[] = [];

  constructor(private usuarioService: UsuarioService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    storageService: UtilStorageService
  ) { super(erroService, storageService) }

  ngOnInit(): void {
    this.listarUsuarios();
  }

  listarUsuarios() {
    this.loading = true;
    this.usuarioService.listarPorAdministradoraId(this.getAdministradora().id).subscribe({
      next: (data: Usuario[]) => {
        this.usuarios = data;
        this.loading = false;
      },
      error: (err: any) => this.exibirMensagemErro(err)
    });
  }

  editar(id: number){
    this._router.navigate(["/rfarias/usuario-franquia/editar/" + id],
       { relativeTo: this._activatedRoute });
  }

  detalhar(id: number){
    this._router.navigate(["/rfarias/usuario-franquia/detalhar/" + id],
       { relativeTo: this._activatedRoute });
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

}
